const en = {
  modules: {
    sessionWatcher: {
      reason: 'The session has expired! Please log in.'
    }
  }
};

export default en;
